module.exports = __webpack_public_path__ + "img/main_logo.0f541ce5.svg";